import React from 'react';
import './FootnoteIcon.css';
import ReactTooltip from 'react-tooltip';

const FootnoteIcon = props => {
  
  const { footnotes, number } = props;

  return (
    <span>
      <button className="footnote-icon" 
        data-tip={ footnotes[number-1] } 
        data-effect="solid" 
        data-html={ true } 
        data-border
        data-event="click">{ number }</button>
      <ReactTooltip wrapper="span" class="tooltip" globalEventOff="click"/>
    </span>
  )
}

export default FootnoteIcon;


// WEBPACK FOOTER //
// ./src/components/FootnoteIcon.js